import { type Data, type ListData } from 'core/domain/Request'
import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import { type Driver } from '../domain/Driver'
import { type RawDriver, mapApiToDriver, mapDriverToApi } from './driverMapper'

const BASE_URL = '/api/v2/carrier/drivers'

type DriverRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class DriverRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: DriverRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getDrivers(config?: Partial<HttpClientConfig>): Promise<Array<Driver>> {
    const endpoint = BASE_URL
    const { data } = await this.httpClient.get<ListData<RawDriver>>(endpoint, config)
    return data.data.map(driver => mapApiToDriver(driver))
  }

  async getDriver(id: string, config?: Partial<HttpClientConfig>): Promise<Driver> {
    const endpoint = `${BASE_URL}/${id}`
    const { data } = await this.httpClient.get<Data<RawDriver>>(endpoint, config)
    return mapApiToDriver(data.data)
  }

  async createDriver(driver: Driver, config?: Partial<HttpClientConfig>): Promise<Driver> {
    const endpoint = BASE_URL
    const rawDriver = mapDriverToApi(driver)
    const { data } = await this.httpClient.post<Data<RawDriver>>(endpoint, rawDriver, config)
    return mapApiToDriver(data.data)
  }

  async updateDriver(driver: Driver, config?: Partial<HttpClientConfig>): Promise<Driver> {
    const endpoint = `${BASE_URL}/${driver.id}`
    const rawDriver = mapDriverToApi(driver)
    const { data } = await this.httpClient.post<Data<RawDriver>>(endpoint, rawDriver, config)
    return mapApiToDriver(data.data)
  }
}
